// plugins/sentry.client.ts
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp
  const config = useRuntimeConfig()

  if(config.public.environment !== 'local') {
    Sentry.init({
      app: [vueApp],
      dsn: 'https://fc6b1c7e407d0721a9f3d374611d10ea@o1128448.ingest.us.sentry.io/4506950636011520',
      environment: process.dev ? 'development' : 'production',
      integrations: [
        new BrowserTracing()
      ],
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      beforeSend (event, hint) {
        if (event.exception) {
          // eslint-disable-next-line no-console
          console.error(`[Exeption handled by Sentry]: (${hint.originalException})`, { event, hint });
        }

        return event;
      }
    });

    vueApp.mixin(Sentry.createTracingMixins({ trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] }));
    Sentry.attachErrorHandler(vueApp, { logErrors: false, attachProps: true, trackComponents: true, timeout: 2000, hooks: ['activate', 'mount', 'update'] });

    return {
      provide: {
        sentrySetContext: Sentry.setContext,
        sentrySetUser: Sentry.setUser,
        sentrySetTag: Sentry.setTag,
        sentryAddBreadcrumb: Sentry.addBreadcrumb,
        sentryCaptureException: Sentry.captureException
      }
    };
  }
})
